/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./avatar.vue?vue&type=template&id=3ea38864&scoped=true&"
import script from "./avatar.vue?vue&type=script&lang=ts&setup=true&"
export * from "./avatar.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./avatar.vue?vue&type=style&index=0&id=3ea38864&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea38864",
  null
  
)

export default component.exports